/**
 * Redux Provider wrapper for CreateVideoNewPage
 */

import React from 'react';
import { Provider } from 'react-redux';
import { store } from './index';

export function CreateVideoNewPageProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}

